import { Controller } from '@hotwired/stimulus'

// This controller is used to handle the SIP number input and toggle the SIP section visibility
// 2 ways to trigger the sip form
//   1. Check for "sip:" in the number input
//   2. Click the SIP toggle switch
export default class extends Controller {
    static targets = ['numberInput', 'sipSection', 'sipToggle']

    connect() {
        this.checkForSip()
    }

    checkForSip() {
        if (!this.hasNumberInputTarget || !this.hasSipToggleTarget) return

        const isSip = this.numberInputTarget.value.startsWith('sip:')
        this.sipToggleTarget.checked = isSip
        this.updateVisibility()
    }

    toggleMode() {
        this.updateVisibility()
    }

    updateVisibility() {
        if (!this.hasSipToggleTarget || !this.hasSipSectionTarget) return

        if (this.sipToggleTarget.checked) {
            this.sipSectionTarget.classList.remove('d-none')
        } else {
            this.sipSectionTarget.classList.add('d-none')
        }
    }

    // RET-600: Explicitly calling turbo stream here since the target form isn't
    // yet using Turbo fully. Remove when we fully delete ajax_errors.js.
    async addHeader(event) {
        event.preventDefault()
        const response = await fetch(event.currentTarget.href, {
            headers: { Accept: 'text/vnd.turbo-stream.html' },
        })
        const html = await response.text()
        Turbo.renderStreamMessage(html)
    }

    removeHeader(event) {
        const row = event.target.closest('.sip-header-row')
        const destroyField = row.querySelector('[name*="_destroy"]')
        if (destroyField) {
            destroyField.value = '1'
        }
        row.classList.add('d-none')
    }
}
